import {
	GET_TEST_DATA,
	GET_TEST_DATA_SUCESS,
	API_ERROR,
} from "./actionTypes";

export const getTestData = params => ({
	type: GET_TEST_DATA,
	payload: params
});

export const getTestDataSuccess = res => ({
	type: GET_TEST_DATA_SUCESS,
	payload: res
});

export const apiError = error => ({
	type: API_ERROR,
	payload: error
});
